import { put, call, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalNotifications";
import {
  getCompanyNotificationsResponse,
  getCompanyDropdownNotificationsResponse,
  setCompanyUnseenNotificationsCount,
  replaceCompanyNotification,
} from "./actions";
import * as types from "./types";
import { showErrorMsg } from "../../../utils/Helpers";

function* getCompanyNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyPortalNotifications, payload);
    yield put(
      getCompanyNotificationsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      }),
    );
    yield put(setCompanyUnseenNotificationsCount(0));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* getCompanyDropdownNotificationsSaga({ payload }) {
  try {
    const response = yield call(apis.getCompanyPortalNotifications, payload);
    yield put(getCompanyDropdownNotificationsResponse(response.data.data));
    yield put(setCompanyUnseenNotificationsCount(0));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

function* setCompanyNotificationSeenSaga({ payload }) {
  try {
    const response = yield call(apis.setCompanyPortalNotificationSeen, payload);
    yield put(replaceCompanyNotification(response.data.data));
  } catch (error) {
    if (error.response) {
      yield call(showErrorMsg, error.response?.data?.message);
    }
  }
}

export default function* CompanyNotificationsSagas() {
  yield takeEvery(
    types.GET_COMPANY_NOTIFICATIONS_REQUEST,
    getCompanyNotificationsSaga,
  );
  yield takeEvery(
    types.GET_COMPANY_DROPDOWN_NOTIFICATIONS_REQUEST,
    getCompanyDropdownNotificationsSaga,
  );
  yield takeEvery(
    types.SET_COMPANY_NOTIFICATION_SEEN,
    setCompanyNotificationSeenSaga,
  );
}
